import { paymentDirectionMap } from "features/Payments/constants/payment.constants";
import { Payment } from "features/Payments/types/payment.types";

const PaymentDirectionBadge = ({ record }: { record: Payment | null }) => {
  const directionMeta = record ? paymentDirectionMap[record.direction] : null;
  return (
    <span title={directionMeta?.hint}>{directionMeta?.label}</span>
  );
};

export default PaymentDirectionBadge;
